import React from "react";
import TableAction from "../../TableAction";
import { LessonsButtonProps } from "./LessonsButton.types";

/**
 * Compatibility wrapper for legacy call sites.
 * The visual contract lives in reusable TableAction.
 */
const LessonsButton: React.FC<LessonsButtonProps> = ({
  href,
  text,
  noLessons,
  queryParams,
}) => (
  <TableAction
    href={href}
    queryParams={queryParams}
    text={text || "Смотреть"}
    disabled={Boolean(noLessons)}
  />
);

export default LessonsButton;
